// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52eb4b7a","257":"73c468cb","453":"d5e57574","455":"b4376365"}[chunkId] + ".chunk.js";
};